export const STORAGE_KEY = {
  TODO: 'todos',
  THEME_KEY: 'theme',
};
